import { gql } from '@lcs/shared/api';

// Query for getting extensions with pagination
export const getExtensionsQuery = gql`
   query GetExtensions($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      extensionsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            account {
               accountId
               defaultAreaCode
            }
            extensionId
            name
            number
            type
            extensionType {
               displayName
            }
            extensionPhone {
               defaultPhoneNumber {
                  phoneNumber
               }
               ringTimeout
            }
            phonesConnection {
               items {
                  phoneId
                  phoneType
                  handsetIpei
                  baseStationHandsetsConnection {
                     items {
                        baseStationHandsetId
                        phoneId
                        sortId
                        device {
                           deviceId
                           deviceTypeId
                           macAddress
                           description
                        }
                     }
                  }
                  numberOfLineKeys
                  devicesConnection {
                     items {
                        deviceId
                        deviceTypeId
                        macAddress
                        lastProvisionedDate
                     }
                  }
                  sipUsersConnection {
                     items {
                        sipUserId
                        userName
                        isHacked
                        isFraud
                        isConnected
                        phone {
                           phoneId
                           phoneType
                           devicesConnection {
                              items {
                                 deviceId
                                 deviceTypeId
                                 macAddress
                              }
                           }
                        }
                     }
                  }
               }
            }
            phoneRegistrationRank
         }
      }
      extensionGroupsConnection(after: $after) {
         items {
            name
            description
            extensionGroupId
            accountId
         }
      }
   }
`;

export const getExtensionsForAddQuery = gql`
   query GetExtensionsForAdd(
      $filtersExtensions: String
      $filtersExtensionGroups: String
      $after: String
      $orderingOptions: [OrderingOption!]
   ) {
      extensionsConnection(filters: $filtersExtensions, after: $after, orderingOptions: $orderingOptions) {
         items {
            account {
               accountId
               defaultAreaCode
            }
            extensionId
            name
            number
            type
            extensionType {
               displayName
            }
         }
      }
      extensionGroupsConnection(filters: $filtersExtensionGroups, after: $after) {
         items {
            name
            description
            extensionGroupId
            accountId
         }
      }
   }
`;

export const getExtensionNumbersQuery = gql`
   query GetExtensionNumbers($filtersExtensions: String, $after: String, $orderingOptions: [OrderingOption!]) {
      extensionsConnection(filters: $filtersExtensions, after: $after, orderingOptions: $orderingOptions) {
         items {
            accountId
            extensionId
            number
            type
         }
      }
   }
`;

export const getExtensionIdsQuery = gql`
   query GetExtensionIds($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      extensionsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            extensionId
         }
      }
   }
`;
